import { useTranslation } from 'next-i18next';

import type { AppLocale } from '../../utils/i18n';

export function useLanguage() {
  const { i18n } = useTranslation();
  return i18n.language as AppLocale;
}
